/**
 * Some spor components are overridden by drops components. Each of these are a full
 * replacement of the Spor components, with corrected colors and extra options available
 */

// Imports:
import { Tooltip as InternalTooltip } from "shared/components/drops/DropsTooltip";

import { InternalDropsBadge } from "shared/components/drops/DropsBadge";
import { InternalDropsButton } from "shared/components/drops/DropsButton";
import { InternalDropsCheckbox } from "shared/components/drops/DropsCheckbox";
import { InternalDropsDatePicker } from "shared/components/drops/DropsDatePicker";
import { InternalDropsDialogContent } from "shared/components/drops/DropsDialogContent";
import { InternalDropsDialogHeader } from "shared/components/drops/DropsDialogHeader";
import { InternalDropsExpandable } from "shared/components/drops/DropsExpandable";
import { InternalDropsMenuCheckboxItem } from "shared/components/drops/DropsMenuCheckboxItem";
import { InternalDropsStaticAlert } from "shared/components/drops/DropsStaticAlert";
import { withDefaults } from "shared/utils/withDefaults";

// Exports (With Documentations):
export * from "@vygruppen/spor-react";

// Documentations are visible by hovering the component
/**
 * Old Drops version of { Badge } from "shared/components/Spor";
 * Includes a prop 'Semantics' which styles the button to fit that 'Severity' value.
 * @deprecated Use the \<Badge />  component instead, it now has sidespor expansions
 */
export const DropsBadge = InternalDropsBadge;

/**
 * Drops version of { StaticAlert } from "shared/components/Spor";
 * The prop 'Variant' styles the component with our theme colors.
 */
export const DropsStaticAlert = InternalDropsStaticAlert;
/**
 * Use Drops version instead
 */
export const StaticAlert = null; // Remove access to StaticAlert

/**
 * Drops version of { Button } from "shared/components/Spor";
 * Includes a prop 'Severity' which styles the button to fit that 'Severity' value.
 */
export const DropsButton = InternalDropsButton;
/**
 * Use Drops version instead
 */

/**
 * Drops version of { Expandable } from "shared/components/Spor";
 * Adds a DashedLine between Trigger and Body, as well as fixing Outline/Background for Trigger and Body.
 * Fixes the typing of title to allow JSX.Element as well
 */
export const DropsExpandable = InternalDropsExpandable;

export const DropsCheckbox = InternalDropsCheckbox;

/**
 * Use Drops version instead
 */
export const Expandable = null;

/**
 * Drops version of { DialogHeader } from "shared/components/Spor";
 * Uses the correct padding and fontsize, as well as including the DialogCloseTrigger.
 */
export const DropsDialogHeader = InternalDropsDialogHeader;
/**
 * Use Drops version instead
 */
export const DialogHeader = null;

/**
 * Drops version of { DialogContent } from "shared/components/Spor";
 * The prop 'Semantics' styles the component with our theme colors.
 */
export const DropsDialogContent = InternalDropsDialogContent;
/**
 * Use Drops version instead
 */
export const DialogContent = null;

/**
 * Drops version of { DatePicker } from "shared/components/Spor";
 * Forces you to include withPortal which is must be set to false to work in dialogs
 */
export const DropsDatePicker = InternalDropsDatePicker;
/**
 * Use Drops version instead
 */
export const DatePicker = null;

export const MenuCheckboxItem = InternalDropsMenuCheckboxItem;

/**
 * We use this chakra component often, it would be more beneficial to get it
 * instead when we import from "shared/components/Spor"; so that we dont have to maintain
 * two different variants of the same component if we import then interchangeably.
 */
export const Tooltip = withDefaults(InternalTooltip, (theme) => ({
  style: {
    color: theme.colorBackgroundMain,
    backgroundColor: theme.colorSuccessTextSecondary,
    padding: "6px",
    borderRadius: "12px",
  },
}));
